import Dispatcher from "Dispatcher";
import PropTypes from "prop-types";
import { ReduceStore } from "flux/utils";
import typeCheckingStore from "data/util/typeCheckingStore";
import OverActions from "./OverActions";
import { isConfirmed } from "./OverStore";
import SessionActions from "./SessionActions";

class NavigationStore extends ReduceStore {

    constructor() {
        super(Dispatcher);
    }

    getInitialState() {
        return {
            promptExternalNavigation: true,
        };
    }

    reduce(state, action) {
        switch (action.type) {
            case SessionActions.timeout: {
                return {
                    promptExternalNavigation: false
                };
            }
            case OverActions.EXTERNAL_NAV: {
                if(isConfirmed(action)) {
                    return {
                        promptExternalNavigation: false
                    };
                }
                return state;
            }
            default:
                return state;
        }
    }

    canPromptExternalNavigation() {
        return this.getState().promptExternalNavigation;
    }

}

NavigationStore.stateTypes = {
    promptExternalNavigation: PropTypes.bool.isRequired,
};

export default typeCheckingStore(new NavigationStore());



// WEBPACK FOOTER //
// ./app/data/NavigationStore.js